<template>
  <div class="container-fluid bg-light">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col d-flex justify-content-center align-items-center vh-100">
        <div class="card shadow">
          <img src="@/assets/images/logo-wide-black.png" class="card-img-top pt-4 px-4" />
          <div class="card-body">
            <div v-if="errorMessage" class="alert alert-danger" role="alert">
              {{ errorMessage }}
            </div>
            <div v-if="infoMessage" class="alert alert-primary" role="alert">
              {{ infoMessage }}
            </div>
            <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
              <div class="form-group">
                <label for="emailAddress">Email</label>
                <input
                  v-model="emailAddress"
                  type="email"
                  class="form-control"
                  id="emailAddress"
                  placeholder="Email"
                  required
                  :disabled="isWorking"
                  @keyup.enter="next"
                />
                <div class="invalid-feedback">
                  Please provide your email address.
                </div>
              </div>
              <button type="button" class="btn btn-primary btn-block" @click="next" :disabled="isWorking" @keyup.enter="next">
                <span v-if="isWorking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Next
              </button>
              <small class="form-text text-muted text-right">
                <router-link to="/signin/forgot" v-slot="{ href, navigate }">
                  <a class="btn btn-link btn-sm" :href="href" @click="navigate">Forgot your password?</a>
                </router-link>
              </small>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isWorking: false,

      emailAddress: null,

      formWasValidated: false,
      infoMessage: null,
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters("signin", ["redirect"]),
    ...mapGetters("user", ["user"]),
  },
  created() {
    if (this.user) {
      this.$router.push(this.redirect);
      this.$store.commit("signin/setRedirect", "/");
      return;
    }

    // Pre-fill email if passed from forgot password page
    if (this.$route.query.email) {
      this.emailAddress = this.$route.query.email;
      // Auto-trigger next step if email is provided
      this.$nextTick(() => this.next());
    }
  },
  methods: {
    ...mapActions("workos", {
      workosSignIn: "signIn",
    }),
    reset() {
      this.isWorking = false;
      this.formWasValidated = false;
      this.infoMessage = null;
      this.errorMessage = null;
    },
    async next() {
      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // check org auth provider via sso/begin endpoint
      this.isWorking = true;
      try {
        const res = await this.$axios.post("/v1/signin/sso/begin", { emailAddress: this.emailAddress });

        // org uses WorkOS - redirect to WorkOS (handles both SSO and email/password)
        if (res.data.authProvider === "workos") {
          await this.workosSignIn(this.emailAddress);
          return;
        }

        // no matching organization found for this email
        this.reset();
        this.errorMessage = "We couldn't find an account for that email address. Please check the address and try again.";
      } catch (err) {
        this.reset();
        this.errorMessage = (err.response && err.response.data && err.response.data.detail) || "Something went wrong. Please try again.";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 400px;
}
</style>
